import cnames from 'classnames'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'
import Link from 'Shared/Link/Link'

const MembershipAlert = ({ error, success, url }) => {
  const alertClasses = cnames('alert mt-2 mb-0', {
    'alert-success': success, 'alert-danger formik-error-message': error || !success,
  })

  const getContent = () => {
    if (success) return (
      <>
        <FontAwesomeIcon icon="party-horn" className="me-2" />

        <span>Membership verified. You're good to go!</span>
      </>
    )

    if (error) return <span>{error}</span>

    return (
      <>
        <p className="text-red fw-bold">Invalid or inactive membership</p>

        <p className="text-red mb-0">
          Please check your code or&nbsp;

          <Link className="text-red text-decoration-underline" isExternal target="_blank" to={url}>
            click here
          </Link>

          &nbsp;to renew your membership.
        </p>
      </>
    )
  }

  return (
    <div className={alertClasses}>
      {getContent()}
    </div>
  )
}

export default MembershipAlert
